import React, { useEffect, useState } from "react";
import { formRequestServices } from "api/services";
import { IResFormRequest } from "api/services/form-request/types";
import { useParams } from "react-router-dom";
import { MainTemplate } from "shared/MainTemplate/MainTemplate";
import { useHistory } from "react-router";
import { Button } from "@material-ui/core";
import "./FormItemPage.sass";
import { SERVER_URL } from "constants/project";

export const FormItemPage: React.FC = () => {
	const { formId, reqId } = useParams<{ formId: string; reqId: string }>();
	const [request, setRequest] = useState<IResFormRequest>();
	const history = useHistory();

	useEffect(() => {
		getRequest();
	}, []);
	const getRequest = async () => {
		const res = await formRequestServices
			.getFormRequestById(Number(reqId), { formId: Number(formId) })
			.then((res) => res.data);
		setRequest(res);
	};

	return (
		<MainTemplate title='Заявка' hideBtn>
			<div className='form-item-page'>
				<li className='form-item-page__about'>
					<li className='form-item-page__about-item'>Имя:</li>
					<li className='form-item-page__about-item'>{request?.data?.name}</li>
					<li className='form-item-page__about-item'>Телефон:</li>
					<li className='form-item-page__about-item'>{request?.data?.phone}</li>
					<li className='form-item-page__about-item'>Email:</li>
					<li className='form-item-page__about-item'>{request?.data?.email}</li>
					<li className='form-item-page__about-item'>Сообщение:</li>
					<li className='form-item-page__about-item'>
						{request?.data?.message}
					</li>
				</li>
				<div
					className='form-item-page__exit'
					onClick={() => history.push(`/forms/${Number(formId)}`)}
				>
					<Button color='primary' variant='contained'>
						Назад
					</Button>
				</div>
			</div>
		</MainTemplate>
	);
};
